import ModalDetallesMontos from '../components/ModalDetallesMontos.vue';

export default {
  components: {
    ModalDetallesMontos,
  },
  methods: {
    abrirModal() {
      this.$refs.modalDetallesMontosRef.abrir();
    },
  },
};
